// extracted by mini-css-extract-plugin
module.exports = {"OpportunityLocations":"_2eYgQxGs"};